/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import {
  Route, useHistory, useLocation, useParams,
} from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import EmptyPageLoader from '../../components/EmptyPageLoader';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';
import { useGlobalState } from '../../contexts';
import { GET_ADMIN_CUSTOMER_BY_ID_V3 } from '../../graphql/admin_queries';
import useCustomQuery from '../../network/useCustomQuery';
import GoBackIcon from '../../svgs/GoBackIcon';
import { adminHasPermission, cleanSingleCustomerRecord } from '../../utils/helpers';
import { formatCash } from '../../utils/tableHelpers';
import { AdminRouteName } from '../CONSTANTS';
import AdminTab from '../../components/AdminTab';
import PermissionDenied from '../PermissionDenied';
import CustomerDetailsComment from './CustomerDetailsComment';
import CustomerDetailsLoan from './CustomerDetailsLoans';
import CustomerDetailsRepayment from './CustomerDetailsRepayment';
import CustomerProfile from './CustomerProfile';
// import CustomerTransactions from './CustomerTransactions';
import DocumentPage from './Document/indxe';
import { PersonalInfoEdit } from './CustomerProfileEdit/PersonalInfoEdit';
import ResidentialDetailsEdit from './CustomerProfileEdit/ResidentialDetailsEdit';
import InstitutionDetailEdit from './CustomerProfileEdit/InstitutionDetailEdit';
import UserDetailsCardCa from '../../components/UserDetailsCardCa';
import TransactionTableRecords from '../transactions/CanadaRent/TransactionTableRecord';
import Wallet from './Wallet';

import './CustomerDetails.scss';

const formatPayload = (data: any) => {
  const result: any = cleanSingleCustomerRecord(data?.getUserByIdAdmin) || {};
  result.monthlyIncome = formatCash(result?.monthlyIncome, 'CAD');
  return result;
};

const CustomerDetails = () => {
  const history = useHistory();
  const { profile } = useGlobalState();
  const { pathname } = useLocation();
  const { push } = useHistory();
  const [removeUserDetailsTab, setRemoveUserDetailsTab] = useState(false);
  const [payload, setPayload] = useState({});
  const { customerId } = useParams<{ customerId: string }>();
  const [getCustomerById, loading, data] = useCustomQuery({
    query: GET_ADMIN_CUSTOMER_BY_ID_V3,
    onError: (err: any) => {
      if (err) {
        return push(`/${AdminRouteName.notFoundRoute}`);
      }
    },
    onData: () => {},
  });

  useEffect(() => {
    if (data?.getUserByIdAdmin) {
      setPayload(formatPayload(data));
    }
  }, [data]);

  const adminPermissons = profile?.role?.permissions?.map((permission) => permission.name);

  const fetchCustomer = useCallback(
    () => getCustomerById({ variables: { id: customerId } }),
    [customerId],
  );

  useEffect(() => {
    fetchCustomer();
  }, []);

  useEffect(() => {
    if (pathname === `/customers/customer-details/${customerId}/student-details`) {
      return setRemoveUserDetailsTab(true);
    }
    if (pathname === `/customers/customer-details/${customerId}/institution-details`) {
      return setRemoveUserDetailsTab(true);
    }
    if (pathname === `/customers/customer-details/${customerId}/residential-details`) {
      return setRemoveUserDetailsTab(true);
    }
    if (pathname === `/customers/customer-details/${customerId}/documents`) {
      return setRemoveUserDetailsTab(true);
    }
    return setRemoveUserDetailsTab(false);
  }, [pathname, customerId]);

  const TabsRaw: any = [
    { name: 'Profile', link: `/customers/customer-details/${customerId}/profile`, permission: 'can-view-customer-profile' },
    {
      name: 'Transactions', link: `/customers/customer-details/${customerId}/transactions`, permission: 'can-view-all-transactions',
    },
    {
      name: 'Credit Request', link: `/customers/customer-details/${customerId}/loan/credits`, permission: 'can-view-all-credit-request', activeRoute: [`/customers/customer-details/${customerId}/loan/guarantee`],
    },
    { name: 'Repayment', link: `/customers/customer-details/${customerId}/repayment`, permission: 'can-get-repayments' },
    // CHANGE THE PERMISSION FOR WALLET
    { name: 'Wallet', link: `/customers/customer-details/${customerId}/wallet`, permission: 'can-get-repayments' },
    { name: 'Comments', link: `/customers/customer-details/${customerId}/comments`, permission: 'can-get-user-comments' },
  ];

  const TabsWithPermission = useMemo(() => {
    const Tabs = TabsRaw?.map((tab) => ({
      ...tab,
      disabled: !adminHasPermission(adminPermissons, tab.permission),
    }));
    return Tabs;
  }, [adminPermissons, TabsRaw]);

  return (
    <DashboardWrap className="customer-details-dashboard">
      <div className="customer-details-dashboard-loader" style={{ display: loading ? 'block' : 'none' }}>
        <EmptyPageLoader />
      </div>

      <div className="coustomer-details-cover" style={{ display: loading ? 'none' : 'block' }}>
        <div className="title">
          <GoBackIcon onClick={() => history?.goBack()} />
          Customers
        </div>
        {
          !removeUserDetailsTab && (
          <div>
            <UserDetailsCardCa payload={payload} showAvatarOrInitials hideLocation fetchUser={getCustomerById} dropdownType="adminCustomer" />
            <AdminTab tabs={TabsWithPermission} />
          </div>
          )
        }

        <div className="customer-page-cover">
          <Route path={AdminRouteName.customerDetailsProfileRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-profile" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <CustomerProfile payload={payload} refetchCustomerById={fetchCustomer} customerId={customerId} />
            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerResidentialDetailEditRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-profile" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <ResidentialDetailsEdit payload={payload} fetchCustomer={fetchCustomer} customerId={customerId} />

            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerDetailsProfileEditRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-profile" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <PersonalInfoEdit payload={payload} fetchCustomer={fetchCustomer} customerId={customerId} />

            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerInstututionDetailEditRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-profile" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <InstitutionDetailEdit
                payload={payload}
                fetchCustomer={fetchCustomer}
                customerId={customerId}
              />

            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerDetailsDocumentsRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-document" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <DocumentPage payload={payload} fetchUser={fetchCustomer} />
            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerDetailsTransactionsRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-transactions" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <TransactionTableRecords payload={payload} defaultUrl={`/customers/customer-details/${customerId}/transactions`} toggleStorageId="customer-details-transaction-table-col" userId={customerId} recordPermission="can-view-all-transaction-tab" noSubTab />
            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerDetailsLoanRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-loan-record" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <CustomerDetailsLoan payload={payload} />
            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerDetailsLoanGuaranteeRoute}>
            <RolesAndPermissionGuard permissionName="can-view-customer-loan-record" hasErrorTemplate={<PermissionDenied height="70vh" />}>
              <CustomerDetailsLoan payload={payload} />
            </RolesAndPermissionGuard>
          </Route>
          <Route path={AdminRouteName.customerDetailsRepaymentRoute}>
            <CustomerDetailsRepayment />
          </Route>
          <Route path={AdminRouteName.customerDetailsWalletRoute}>
            <Wallet />
          </Route>
          <Route path={AdminRouteName.customerDetailsCommentRoute}>
            <CustomerDetailsComment />
          </Route>
        </div>
      </div>
    </DashboardWrap>
  );
};

export default CustomerDetails;
